import LargeFormat from "@/pages/LargeFormat";
import { STICKER_CONFIG } from "@/pages/estimatorConfig";

// Stickers reuse the entire Large Format experience in "sticker mode":
// 52×36 repeatable sections, layout-driven quantity, kiss-cut default, per-piece laminate/decoration.
export default function Stickers() {
  return <LargeFormat key="sticker-module" variant="sticker" config={STICKER_CONFIG} />;
}
